import { render, staticRenderFns } from "./sqlEditor.vue?vue&type=template&id=1d248849&scoped=true&"
import script from "./sqlEditor.vue?vue&type=script&lang=js&"
export * from "./sqlEditor.vue?vue&type=script&lang=js&"
import style0 from "./sqlEditor.vue?vue&type=style&index=0&id=1d248849&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d248849",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
